import type { AxiosError } from 'axios';
import { clearJwtTokens, readJwtToken } from './auth-tokens';
import { saveReturnTo } from './return-to';

// Match authentication failures only, never ordinary permission denials or outages.
export const isInvalidSession = (error: AxiosError) => {
  const data = error.response?.data as { type?: string; subtype?: string } | undefined;
  return (error.response?.status === 401 || error.response?.status === 403)
    && !!data?.type?.startsWith('ERROR-CHECK-TOKEN')
    && ['invalid signature', 'jwt expired', 'jwt malformed', 'invalid token',
      'NO-TOKEN-PROVIDED', 'NO-DECODED-TOKEN', 'VERIFICATION-REQUIRED'].includes(data.subtype || '');
};
let redirecting = false;
export const recoverInvalidSession = (error: AxiosError) => {
  if (!isInvalidSession(error)) return false;
  if (redirecting) return true;
  const authorization = String(error.config?.headers?.Authorization || '');
  const persona = authorization === `Bearer ${readJwtToken('prospect', false)}`
    || error.config?.baseURL?.includes('prospect-dashboard') ? 'prospect' : 'user';
  if (authorization && authorization !== `Bearer ${readJwtToken(persona, true)}`) return true;
  redirecting = true;
  const destination = new URL(window.location.href);
  destination.searchParams.delete('token');
  if (!destination.pathname.startsWith('/t/')) saveReturnTo(destination.pathname + destination.search);
  clearJwtTokens([persona, 'legacy']);
  try { localStorage.removeItem('token'); } catch { /* Storage can be unavailable. */ }
  if (!window.location.pathname.startsWith('/login')) window.location.replace('/login');
  return true;
};
